import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import * as ProfileCompletionActions from '@planone/bau365/data-access-user';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import * as FeatureTrackingSnowplow from '@planone/shared/feature-tracking-snowplow';
import { of, switchMap, withLatestFrom } from 'rxjs';

import { CustomEventIglu } from '../../tracking-types/snowplow/schema/schema.interface';

@Injectable()
export class ProfileCompletionEffects {
  completion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileCompletionActions.profileCompletion),
      withLatestFrom(this.authenticationFacade.excludeAnalytics$),
      switchMap(([action, exclude_analytics]) =>
        of(
          FeatureTrackingGoogleAnalytics.push({
            event: 'add_professional_information',
            profession:
              (action['professional-information'] ?? []).find((item) => item.name === 'PROFESSION')?.ids[0] ??
              action?.current?.profession,
            specialization:
              (action['professional-information'] ?? []).find((item) => item.name === 'SPECIALIZATION')?.ids[0] ??
              action?.current?.specialization,
            context: action.context,
            page_type: 'profile-completion',
          }),
          FeatureTrackingSnowplow.selfDescribingEvent({
            event: {
              schema: CustomEventIglu.edit_personalization,
              data: {
                interests: action.interests,
                type: action.profileCompletionType,
                context: action.context,
                exclude_analytics: exclude_analytics,
                'professional-information': action['professional-information'],
              },
            },
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private store: Store,
    private authenticationFacade: AuthenticationFacade
  ) {}
}
